// extracted by mini-css-extract-plugin
export var angry = "freshness-table-module--angry--7a258";
export var bored = "freshness-table-module--bored--68b5f";
export var disappointed = "freshness-table-module--disappointed--6d648";
export var happy = "freshness-table-module--happy--e585f";
export var labelCol = "freshness-table-module--labelCol--a96d0";
export var state = "freshness-table-module--state--ba938";
export var table = "freshness-table-module--table--523b3";
export var wasAngry = "freshness-table-module--wasAngry--8545b";